import React, { useState } from 'react';
import './RightSidebar.css';

const reminders = [
    { id: 1, type: 'PY', title: 'Python Test', date: 'Wednesday', color: '#8E44AD' },
    { id: 2, type: 'R', title: 'React Class', date: 'March 11', color: '#27AE60' },
    { id: 3, type: 'UI', title: 'UI Workshop', date: 'Monday', color: '#E67E22' },
];

const statistics = [6, 4, 5, 3, 3, 5, 1];
const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
const yAxisValues = [8, 7, 6, 5, 4, 3, 2, 1];

export default function RightPanel() {
    const [completedCourses, setCompletedCourses] = useState(2);
    const [inProgressCourses, setInProgressCourses] = useState(2);

    return (
        <div className="dashboard-right-panel">
            <div className="course-summary-cards">
                <div className="courses-cards completed">
                    <h2>{completedCourses}</h2>
                    <p>Courses Completed</p>
                </div>
                <div className="courses-cards in-progress">
                    <h2>{inProgressCourses}</h2>
                    <p>Courses In progress</p>
                </div>
            </div>

            <div className="reminder-section">
                <h3 className="reminder-title">Reminders</h3>
                {reminders.map((item) => (
                    <div key={item.id} className="reminder-entry">
                        <div className="reminder-badge" style={{ backgroundColor: item.color }}>
                            {item.type}
                        </div>
                        <div className="reminder-info">
                            <p className="reminder-label">{item.title}</p>
                            <p className="reminder-time">{item.date}</p>
                        </div>
                        <button className="reminder-action">Set Reminder</button>
                    </div>
                ))}
            </div>


            <div className="statistics-section">
                <h3 className="statistics-title">Your Statistics</h3>
                <div className="chart-container-2">

                    <div className="y-axis-labels">
                        {yAxisValues.map(value => (
                            <div key={value} className="y-label">{value}</div>
                        ))}
                    </div>

                    <div className="chart-content">
                        <svg width="100%" height="160" viewBox="0 0 280 160">
                            <polyline
                                fill="none"
                                stroke="#5A67D8"
                                strokeWidth="2"
                                points={statistics.map((val, index) => `${40 + index * 40},${160 - val * 20}`).join(' ')}
                            />
                            {statistics.map((val, index) => (
                                <circle
                                    key={index}
                                    cx={40 + index * 40}
                                    cy={160 - val * 20}
                                    r="4"
                                    fill="#5A67D8"
                                />
                            ))}
                        </svg>
                        <div className="day-labels">
                            {days.map(day => (
                                <span key={day}>{day}</span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
